























import Vue from "vue";

import { Channel } from "../../channel/models/Channel";

export default Vue.extend({
  props: {
    value: {
      type: Array as () => number[]
    },
    channels: {
      type: Array as () => Channel[]
    },
    isDisable: {
      type: Boolean
    },
    validations: {
      type: Object
    }
  },
  computed: {
    channelsSelected: {
      get(): number[] {
        return (this as any).value;
      },
      set(channelsSelected: number[]) {
        (this as any).$emit("input", channelsSelected);
      }
    },
    channelError() {
      return (this as any).validations.$error
        ? "channel is required or invalid"
        : "";
    }
  }
});
